
export default {
  name: 'AppInfoDialog',
  props: {
    title: { type: String, required: true }
  }
};
